import React, { useEffect, useMemo } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';

import whatsappIcon from '../../assets/whatsapp.png';

import './styles.css';

function PedidoWhatsapp() {
    const location = useLocation();

    const orderData = useMemo(() => {
        const fallback = localStorage.getItem('last_whatsapp_order');
        return location.state || (fallback ? JSON.parse(fallback) : {});
    }, [location.state]);

    const whatsappUrl = orderData.whatsappUrl || '';

    useEffect(() => {
        if (!whatsappUrl) {
            return;
        }

        const timeout = window.setTimeout(() => {
            window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
        }, 300);

        return () => window.clearTimeout(timeout);
    }, [whatsappUrl]);

    function handleOpenWhatsappButton() {
        if (!whatsappUrl) {
            return;
        }

        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    }

    return (
        <div id="order_complete_container" className="whatsapp_complete_container">
            <header>
                <Link to="/">
                    Voltar ao menu
                    <FiChevronRight size={16}></FiChevronRight>
                </Link>
            </header>
            <main>
                <h1>Obrigado pelo seu pedido!</h1>
                <p>Seu pedido foi registrado corretamente.</p>

                <div className="line" />

                <section className="whatsapp_confirmation_card">
                    <img src={whatsappIcon} alt="WhatsApp" />
                    <h2>Agora enviaremos a confirmação por WhatsApp</h2>
                    <p>
                        Tentaremos abrir o WhatsApp automaticamente com a mensagem preparada,
                        mantendo esta tela aberta. Se não abrir, toque no botão abaixo para continuar.
                    </p>
                </section>

                <button
                    className="whatsapp_button"
                    onClick={handleOpenWhatsappButton}
                    disabled={!whatsappUrl}
                >
                    Abrir WhatsApp
                    <img src={whatsappIcon} alt="WhatsApp" />
                </button>
            </main>
        </div>
    );
}

export default PedidoWhatsapp;
